import { render, staticRenderFns } from "./LearningArea.vue?vue&type=template&id=6e99ab4e&"
import script from "./LearningArea.vue?vue&type=script&lang=js&"
export * from "./LearningArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports